export const buddhaEn: Record<string, string> = {
  "hud.mana": "KARMA (LIFE)",
  "hud.blessing": "MERIT",
  "hud.chapelCost": "Stupa: {{cost}} karma",
  "hud.wallCost": "Boundary: {{cost}} karma",
  "hud.amplifierCost": "Chanter: {{cost}} karma",
  "hud.trapCost": "Snare: {{cost}} karma",
  "hud.shrineCost": "Wheel shrine: {{cost}} karma",
  "hud.relicCost": "Mantra: {{cost}} karma",
  "hud.modeTower": "Stupa",
  "hud.modeWall": "Boundary",
  "hud.modeAmp": "Chanter",
  "hud.modeTrap": "Snare",
  "hud.modeShrine": "Wheel Shrine",
  "hud.mobType.Normal": "Hungry Shades",
  "hud.mobType.Swarm": "Restless Sparks",
  "hud.mobType.Armored": "Iron Attachments",
  "hud.mobType.Giant": "Wheel-Bound Titans",
  "hud.mobType.Runner": "Fleeting Cravings",
  "hud.hint.clickGround": "Click ground: raise stupa",
  "hud.hint.keys": "Keys 1-8: shape mantra",
  "hud.hint.clickChapel": "Click stupa: place mantra",
  "hud.prepSpace": "Space or Wave 1 - begin rite",
  "hud.inventory": "Mantras:",
  "hud.noRelics": "No mantras (press 1-8 to shape)",
  "hud.priest": "Monk Lv {{level}}",
  "hud.grace": "Karma {{grace}}",
  "hud.relics": "MANTRAS",
  "hud.actionSanctify": "Refine",
  "hud.buildChapel": "Stupa",
  "hud.buildWall": "Boundary",
  "hud.buildAmplifier": "Chanter",
  "hud.buildTrap": "Snare",
  "hud.buildShrine": "Wheel Shrine",
  "hud.upgradeCost": "Refinement cost: {{cost}}",
  "map.launchCta": "Begin Rite",
  "map.startDefense": "Begin rite",
  "settings.title": "Rite — {{field}}",
  "settings.begin": "Begin Rite",

  "skills.title": "Practices",
  "skills.grace": "Free: {{n}} / {{total}}",
  "skills.button": "Practices [S]",
  "buddha.skill.0": "Starting karma",
  "buddha.skill.1": "Karma flow",
  "buddha.skill.2": "Return cost",
  "buddha.skill.3": "Cheaper mantras",
  "buddha.skill.4": "Cheaper structures",
  "buddha.skill.5": "Dismantling",
  "buddha.skill.6": "Green flame",
  "buddha.skill.7": "Red resolve",
  "buddha.skill.8": "Blast focus",
  "buddha.skill.9": "Orange thunder",
  "buddha.skill.10": "Lime chain",
  "buddha.skill.11": "Chanter power",
  "buddha.skill.12": "Deeper karma pool",
  "buddha.skill.13": "Dual mantra",
  "buddha.skill.14": "Lucky mantra",
  "buddha.skill.15": "Purple stillness",
  "buddha.skill.16": "Blue severing",
  "buddha.skill.17": "Wheel shrines",
  "buddha.skill.18": "Cyan shock",
  "buddha.skill.19": "Yellow harvest",
  "buddha.skill.20": "Snares",
  "buddha.skill.21": "Mantra damage",
  "buddha.skill.22": "Wild first mantra",
  "buddha.skill.23": "Swift placement",
  "buddha.skill.24": "Faster volleys",
  "buddha.skill.25": "Wider reach",
  "buddha.skill.26": "Marks to karma",
  "buddha.skill.desc.0": "Begin each defense with more karma and a larger life pool.",
  "buddha.skill.desc.1": "Recover karma faster and gain more when an enemy falls.",
  "buddha.skill.desc.2": "Spend less karma when an enemy reaches the hub and must be returned.",
  "buddha.skill.desc.3": "Spend less karma to shape and combine mantras.",
  "buddha.skill.desc.4": "Lower the cost of stupas, boundaries, chanters, snares, and shrines.",
  "buddha.skill.desc.5": "Recover more karma when dismantling a structure.",
  "buddha.skill.desc.6": "Green mantras burn longer and harder.",
  "buddha.skill.desc.7": "Red mantras strike with stronger critical resolve.",
  "buddha.skill.desc.8": "Mantra blasts hit harder when damage spreads.",
  "buddha.skill.desc.9": "Orange mantras strike clusters more effectively.",
  "buddha.skill.desc.10": "Lime mantras chain stronger follow-up hits.",
  "buddha.skill.desc.11": "Chanters empower nearby stupas more effectively.",
  "buddha.skill.desc.12": "Expand the karma pool more cheaply.",
  "buddha.skill.desc.13": "Dual-color mantras keep more of both effects.",
  "buddha.skill.desc.14": "New mantras have a better chance to start at a higher grade.",
  "buddha.skill.desc.15": "Purple mantras hold enemies in stillness longer.",
  "buddha.skill.desc.16": "Blue mantras strip more armor and resistance.",
  "buddha.skill.desc.17": "Wheel shrines release stronger stored karma.",
  "buddha.skill.desc.18": "Cyan mantras shock more reliably.",
  "buddha.skill.desc.19": "Yellow mantras return more karma from hits.",
  "buddha.skill.desc.20": "Snares hit harder and carry mantra effects better.",
  "buddha.skill.desc.21": "All mantra shots deal more damage.",
  "buddha.skill.desc.22": "The first random mantra on a field starts stronger.",
  "buddha.skill.desc.23": "Move and socket mantras more quickly.",
  "buddha.skill.desc.24": "Stupas fire their mantras more often.",
  "buddha.skill.desc.25": "Stupas reach enemies from farther away.",
  "buddha.skill.desc.26": "Field marks become extra starting karma.",

  "buddha.hud.monk": "Monk Lv {{level}}",
  "buddha.hud.karma": "Karma {{grace}}",
  "buddha.story.intro.panel1": "The Wheel turns. Hold the crossings and let no hungry shade reach the hub.",
};
